/**
 * Usage:
 * import i18n from 'i18n'
 *
 * Then call translate like this:
 * i18n.t('hello.world', 'Fallback')
 *
 * See: https://www.i18next.com/ for more information
 */

import 'dayjs/locale/sv';
import * as dayjs from 'dayjs';
import moment from 'moment';

// Update this to reflect what language your page should use
const lang = () => {
    // Hack to get current hostname on SSR, since we cant rely on window there.
    const hostname =
        typeof window === 'undefined'
            ? global.requestedUrl?.hostname
            : window.location.hostname;

    if (hostname?.match(/\.se(\.test)?$/)) {
        return 'sv';
    }

    return 'en';
};

const setGlobalLanguage = (lang) => {
    console.log('Setting language to', lang);
    dayjs.locale(lang);
    moment.updateLocale(lang, {
        week: {
            dow: 1,
        },
    });
};

setGlobalLanguage(lang());

export default {
    language: lang(),
};
